"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAdministrativeDocumentsModel = exports.AdministrativeDocumentModel = void 0;
const validator_1 = require("@leavy/validator");
const validator_2 = require("@leavy/validator");
const AdministrativeDocumentType_1 = require("../../domain/administrative/AdministrativeDocumentType");
/**
 * An administrative document
 */
class AdministrativeDocumentModel {
}
__decorate([
    (0, validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], AdministrativeDocumentModel.prototype, "fileId", void 0);
__decorate([
    (0, validator_1.IsEnum)(AdministrativeDocumentType_1.AdministrativeDocumentType),
    __metadata("design:type", String)
], AdministrativeDocumentModel.prototype, "documentType", void 0);
exports.AdministrativeDocumentModel = AdministrativeDocumentModel;
/**
 * The user's various administrative documents
 */
class UserAdministrativeDocumentsModel {
    constructor() {
        this.documents = [];
    }
}
__decorate([
    (0, validator_1.IsArray)(),
    (0, validator_2.Type)(() => AdministrativeDocumentModel),
    (0, validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], UserAdministrativeDocumentsModel.prototype, "documents", void 0);
exports.UserAdministrativeDocumentsModel = UserAdministrativeDocumentsModel;
//# sourceMappingURL=AdministrativeDocument.js.map